<template>
  <v-app>
        <!-- background: #091d2e;
    color: #132d46; -->
    <!-- <v-app-bar
      app
      color="#132d46"
      dark
      height="80"
    >
      <div class="d-flex align-center">
        <H1>
          QUESTIONARIO ABRACOM
        </H1>
      </div>

      <v-spacer></v-spacer>
      <div class="d-flex align-center">
         <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="@/assets/01-image.jpeg"
          width="100"
        />
      </div>
    </v-app-bar> -->
    <img src="/img/fundo.jpg" alt="" style="position: fixed;top: 0;left: 0;bottom: 0;right: 0;height: 100%;width: 100%;">
    <!-- :style="{'background-image': `url(${/img/fundo.jpg')})`}" -->
    <v-content>
      <v-container class="white pa-0 fill-height">
        <v-layout style="height: 93px;;width:100%;box-shadow: rgb(181, 181, 181) 0px 2px 4px 0px;">
          <v-flex shrink>
            <img  src="/img/det_cab_esq.gif" class="hidden-xs-only" alt="" style="height:100%">
            <!-- <v-img
              alt="Abracom"
              class="shrink mt-1 hidden-sm-and-down"
              contain
              src="/img/det_cab_esq.gif"
              height="100%"
            /> -->
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-img
              alt="Abracom"
              class="shrink mt-1"
              contain
              src="/img/lg_abracom.gif"
              height="100%"
            />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink pr-5>
            <v-img
              alt="Abracom"
              class="shrink mt-1"
              contain
              src="/img/det_cab_dir.gif"
              height="100%"
            />
          </v-flex>
        </v-layout>
        <v-layout style="height: calc(100% - 93px);width:100%;">
          <v-flex xs12 class="pt-5 px-4">
            <router-view/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
     <v-footer class="transparent py-0">
       <v-container style="background: #fefefe">
         <v-layout>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-img
                alt="Boxnet"
                class="shrink mt-1"
                contain
                min-width="100"
                src="/img/boxnet.png"
                width="100"
              />
          </v-flex>
          <v-spacer></v-spacer>
         </v-layout>
       </v-container>
    </v-footer>
    <v-snackbar
      :timeout="snackbarShow.time"
      :color="snackbarShow.color"
      :top="true"
      :right="true"
      v-model="snackbarVisibility"
    >
     {{ snackbarShow.text }}
    </v-snackbar>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
  computed: {
    snackbarShow () {
      return this.$store.getters['snackbar/snackbar']
    },
    snackbarVisibility: {
      get () {
        return this.snackbarShow.visibility
      },
      set () {
        this.$store.commit('snackbar/hide')
      }
    }
  }
}
</script>
